import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { HelpCircle } from 'react-feather';
import config from '../config';
import logoUrl from '../assets/images/logo.svg';
import NavBar from './NavBar';
import styles from './Header.module.scss';

Header.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default function Header({ pages }) {
  const {
    siteName,
    contacts: { email, phoneNo },
    nav: { contactsSlug },
  } = config;

  return (
    <header className={styles.root}>

      <div className={styles.mainBar}>
        <div className={styles.mainBarContainer}>
          <Link className={styles.logo} to="/">
            <img src={logoUrl} alt={siteName} />
          </Link>
          <NavBar pages={pages} />
        </div>
      </div>

      <div className={styles.topBar}>
        <div className={styles.topBarContainer}>
          <ul className={styles.contacts}>
            <li className={styles.contact}>
              <strong>Phone:</strong> <a href={`tel:${phoneNo}`}>{phoneNo}</a>
            </li>
            <li className={styles.contact}>
              <strong>E-mail:</strong> <a href={`mailto:${email}`}>{email}</a>
            </li>
          </ul>
          <Link className={styles.quoteButton} to={`/${contactsSlug}/`}><HelpCircle /> Contact Us</Link>
        </div>
      </div>

    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header.js